/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import { PermissionWrapper } from "../../helpers/permission";
import { InputBox, DropdownBox, CheckBox } from "../../components/Input";
import Select from "react-select"; // Add this import

const AddSubuser = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken");

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: id || "",
        allot_user: [], // This will store array of user IDs
        activate: true
    });
    const [userData, setUserData] = useState({
        user_fullname: "",
        user_role: ""
    });
    const [subuserList, setSubuserList] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]); // For react-select

    const operation = id ? "Edit" : "Add";
    const managePage = `${operation} User`;

    // Fetch user data and subuser list
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                if (id) {
                    // Fetch user details and subuser list from add-team-user endpoint
                    const response = await axios.get(`${API_URL}user/add-team-user/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            accept: '*/*'
                        }
                    });

                    if (response.data) {
                        const { user, subuserlist, userdata } = response.data;

                        // Set user data
                        if (user) {
                            setUserData({
                                user_fullname: user.t1_user_fullname || "",
                                user_role: user.t2_user_role || ""
                            });
                        }

                        // Set subuser list for allocation
                        if (subuserlist && subuserlist.length > 0) {
                            setSubuserList(subuserlist);
                        }

                        // Set existing allocated users if any
                        if (userdata && userdata.length > 0) {
                            // Map the array of integers to an array of strings
                            const allocatedUserIds = userdata.map(id => id.toString());
                            
                            setFormData(prev => ({
                                ...prev,
                                allot_user: allocatedUserIds
                            }));

                            // Set selected options for react-select by matching against subuserlist
                            const selectedOpts = subuserlist
                                .filter(user => allocatedUserIds.includes(user.t1_id.toString()))
                                .map(user => ({
                                    value: user.t1_id.toString(),
                                    label: user.t1_user_fullname
                                }));
                            setSelectedOptions(selectedOpts);
                        }
                    }
                }

            } catch (error) {
                console.error("Error fetching data:", error);
                showToast.error("Failed to load data");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, token]);

    // Handle multi-select change with react-select
    const handleMultiSelectChange = (options) => {
        // Store selected options for display
        setSelectedOptions(options || []);

        // Extract IDs for form data (payload)
        const selectedIds = options
            ? options.map(opt => opt.value.toString())
            : [];

        setFormData(prev => ({
            ...prev,
            allot_user: selectedIds
        }));
    };

    const handleCheckboxChange = (e) => {
        setFormData(prev => ({
            ...prev,
            activate: e.target.checked
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            // Format data according to API requirements
            const payload = {
                id: formData.id,
                allot_user: formData.allot_user, // This will be array of IDs like ["1", "2", "3"]
                activate: formData.activate ? 1 : 0 // Convert boolean to 1/0
            };

            console.log("Submitting payload:", payload); // For debugging

            const response = await axios.post(`${API_URL}user/save-subuser`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'accept': '*/*'
                }
            });

            if (response.data.success) {
                showToast.success(response.data.message || "User saved successfully");
                navigate("/Hrms/User");
            } else {
                showToast.error(response.data.message || "Failed to save user");
            }
        } catch (error) {
            console.error("Error saving user:", error);
            showToast.error(error.response?.data?.message || "An error occurred while saving user");
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate("/Hrms/User");
    };

    // Prepare options for react-select
    const selectOptions = subuserList.map((user) => ({
        value: user.t1_id.toString(),
        label: user.t1_user_fullname
    }));

    return (
        <div className="page-container page-header-fixed page-sidebar-fixed fade in">
            {loading && <LoadingSpinner />}

            <div id="content" className="mt-5">
                <div className="panel panel-default with-rounded-corner with-shadow">
                    <form
                        name="frm1"
                        onSubmit={handleSubmit}
                        className="stdform"
                    >
                        <input type="hidden" name="id" value={formData.id} />

                        <div className="panel-heading">
                            <span className="panel-title">{managePage}</span>
                        </div>

                        <div className="panel-body">
                            <div className="row">

                                {/* User Name */}
                                <div className="col-md-4">
                                    <InputBox
                                        label="User Name"
                                        name="user_fullname"
                                        value={userData.user_fullname}
                                        readOnly={true}
                                        disabled={true}
                                    />
                                </div>

                                {/* Role Name */}
                                <div className="col-md-4">
                                    <InputBox
                                        label="Role Name"
                                        name="user_role"
                                        value={userData.user_role}
                                        readOnly={true}
                                        disabled={true}
                                    />
                                </div>

                                {/* Allocate User - Multi Select using React-Select */}
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Allocate User</label>
                                        <Select
                                            isMulti
                                            name="allot_user"
                                            options={selectOptions}
                                            value={selectedOptions}
                                            onChange={handleMultiSelectChange}
                                            placeholder="Select users to allocate..."
                                            className="basic-multi-select"
                                            classNamePrefix="react-select"
                                            isDisabled={loading}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                        <small className="help-block">
                                            You can select multiple users from the dropdown
                                        </small>
                                    </div>

                                    {/* Show selected users count */}
                                    {/* {selectedOptions.length > 0 && (
                                        <div className="mt-2">
                                            <strong>Selected Users ({selectedOptions.length}):</strong>
                                            <div className="mt-1" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                {selectedOptions.map((user) => (
                                                    <span
                                                        key={user.value}
                                                        className="badge badge-primary"
                                                        style={{
                                                            padding: "6px 12px",
                                                            fontSize: "12px",
                                                            borderRadius: "4px",
                                                            backgroundColor: "#007bff",
                                                            color: "white"
                                                        }}
                                                    >
                                                        {user.label}
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                const newOptions = selectedOptions.filter(opt => opt.value !== user.value);
                                                                handleMultiSelectChange(newOptions);
                                                            }}
                                                            style={{
                                                                marginLeft: "8px",
                                                                background: "none",
                                                                border: "none",
                                                                color: "white",
                                                                cursor: "pointer",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )} */}
                                </div>

                                <div className="clearfix"></div>

                                {/* Set Active Checkbox */}
                                <div className="col-md-12">
                                    <CheckBox
                                        label="Set Active"
                                        name="activate"
                                        checked={formData.activate}
                                        onChange={handleCheckboxChange}
                                    />
                                </div>

                                <div className="clearfix"></div>

                                {/* Save & Cancel Buttons */}
                                <div className="col-md-12 mt-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                        disabled={loading}
                                    >
                                        {loading ? "Saving..." : "Save"}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={handleCancel}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </button>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddSubuser;